import { Button, Link, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { NavLink } from "react-router-dom";

import { useUsers, useAlgolia } from "hooks";
import { appRoutes } from "routes";
import LogoImage from "assets/images/Logo.svg";
import Navigation from "layouts/UserLayout/components/Header/components/Navigation";
import UserPresenter from "presenters/UserPresenter";
import { headerSelector } from "tests/selectors/index.js";

import AccountMenu from "../AccountMenu/AccountMenu";

import { Root, Logo, Nav, Actions, Action } from "./styles";

const DesktopHeader = (props) => {
  const { currentUser } = useUsers();
  const { clearAllFiltersByPath } = useAlgolia();

  return (
    <Root>
      <Link id="header-logo-desktop" to={appRoutes.rootPath()} component={NavLink}>
        <Logo src={LogoImage} width="120px" height="36px" alt="JibJab" />
      </Link>

      <Nav>
        <Navigation {...props} />
      </Nav>

      <Actions>
        <Action>
          <IconButton
            alt="Search"
            component={NavLink}
            id="header-search-desktop"
            aria-label="search"
            to={appRoutes.searchPath()}
            onClick={() => clearAllFiltersByPath({ path: appRoutes.searchPath() })}
            color="text.light"
          >
            <SearchIcon style={{ position: "relative", top: 1 }} />
          </IconButton>
        </Action>

        {UserPresenter.isRegistered(currentUser) && !UserPresenter.isPaid(currentUser) && (
          <Action>
            <Button
              id="header-upgrade-desktop"
              to={appRoutes.paymentPath()}
              data-testid={headerSelector.buttons.upgrade}
              component={NavLink}
              variant="contained"
              color="primary"
            >
              Upgrade
            </Button>
          </Action>
        )}

        {UserPresenter.isRegistered(currentUser) && (
          <Action>
            <AccountMenu />
          </Action>
        )}

        {!UserPresenter.isRegistered(currentUser) && (
          <Action>
            <Link id="header-login-desktop" to={appRoutes.loginPath()} component={NavLink} color="text.light">
              Log in
            </Link>
          </Action>
        )}

        {!UserPresenter.isRegistered(currentUser) && (
          <Action>
            <Button
              id="header-sign-up-desktop"
              to={appRoutes.signUpPath()}
              data-testid={headerSelector.buttons.signup}
              component={NavLink}
              variant="contained"
              color="primary"
            >
              Sign Up
            </Button>
          </Action>
        )}
      </Actions>
    </Root>
  );
};

export default DesktopHeader;
